import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadTask } from 'src/app/model/task-list/load-task';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { _put } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class EditLoadTaskService {
  private readonly put: <T>(
    path: string,
    body: PutRequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as LoadTask;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.put = _put('/task', requestServices);
  }

  public update(requestBody: PutRequestBody): Promise<LoadTask> {
    return this.put('/updateTask', requestBody, this.deserialize).toPromise();
  }
}

export interface PutRequestBody {
  task: LoadTask;
  date: moment.Moment;
  employeeId: number;
}
